import type { Order, OrderFilters, Settings } from '../types'

const now = Date.now()
export const initialMockOrders: Order[] = [
  {
    id: 'm1', source: 'kwork', title: 'Лендинг для онлайн-школы английского',
    description: 'Нужен современный адаптивный лендинг на 7–9 блоков. Есть фирменный стиль, тексты и референсы. Важно подключить формы к Telegram и настроить базовую аналитику.',
    budgetAmount: 45000, budgetCurrency: '₽', displayBudgetAmount: 45000, displayBudgetCurrency: 'RUB', url: 'https://kwork.ru/', publishedAt: new Date(now - 18 * 60_000).toISOString(),
    relevance: 94, scoreSource: 'ai', customer: 'Мария · 12 заказов', favorite: false, status: 'new',
  },
  {
    id: 'm2', source: 'fl', title: 'Корпоративный сайт строительной компании',
    description: 'Разработка сайта по готовому прототипу: главная, услуги, проекты, о компании и контакты. Нужна удобная CMS и хорошая скорость загрузки.',
    budgetAmount: 120000, budgetCurrency: '₽', displayBudgetAmount: 120000, displayBudgetCurrency: 'RUB', url: 'https://www.fl.ru/projects/', publishedAt: new Date(now - 75 * 60_000).toISOString(),
    relevance: 87, scoreSource: 'ai', customer: 'Алексей · безопасная сделка', favorite: true, status: 'viewed',
  },
  {
    id: 'm3', source: 'telegram', title: 'Срочно сверстать промо-страницу',
    description: 'Макет в Figma готов. Нужна pixel-perfect вёрстка, анимация первого экрана и публикация на домене. Срок — четыре дня.',
    budgetAmount: 30000, budgetCurrency: '₽', displayBudgetAmount: 30000, displayBudgetCurrency: 'RUB', url: 'https://t.me/', publishedAt: new Date(now - 3 * 3_600_000).toISOString(),
    relevance: 78, scoreSource: 'fallback', customer: '@digital_jobs', favorite: false, status: 'new',
  },
  {
    id: 'm4', source: 'freelancer', title: 'Лендинг для SaaS-сервиса',
    description: 'Нужна адаптивная маркетинговая страница по готовым макетам Figma. Подойдёт React или чистый HTML/CSS; важна высокая скорость загрузки.',
    budgetAmount: 600, budgetCurrency: '$', displayBudgetAmount: 54000, displayBudgetCurrency: 'RUB', url: 'https://www.freelancer.com/jobs/', publishedAt: new Date(now - 7 * 3_600_000).toISOString(),
    relevance: 72, scoreSource: 'ai', customer: 'Verified client · 4.9', favorite: false, status: 'responded', response: 'Здравствуйте! Готов реализовать ваш лендинг по макету с адаптивной вёрсткой и высокой скоростью загрузки.',
  },
]

export const defaultSettings: Settings = {
  sources: ['kwork', 'fl', 'freelance', 'freelancer', 'weblancer', 'workspace', 'contractis', 'freelancehunt', 'telegram'],
  minBudget: 15000,
  minRelevance: 60,
  keywords: ['лендинг', 'сайт', 'landing page', 'вёрстка', 'корпоративный сайт'],
  stopWords: ['доработка 1с', 'парсинг базы', 'диплом'],
  telegramChannels: [],
  lastSuccessfulScan: new Date(now - 42 * 60_000).toISOString(),
  displayCurrency: 'RUB',
  exchangeRates: { USD: 1, RUB: 90, KGS: 87.5 },
}

export function filterOrders(orders: Order[], filters: OrderFilters, favoritesOnly = false) {
  return orders.filter((order) => {
    if (favoritesOnly && !order.favorite) return false
    if (!filters.sources.includes(order.source)) return false
    if (order.displayBudgetAmount !== null && order.displayBudgetAmount < filters.minBudget) return false
    if (order.relevance < filters.minRelevance) return false
    return filters.statuses.includes(order.status)
  })
}
